import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Button, ErrorSummary } from 'govuk-react-jsx';
import { checkValidEmail } from '../../regex/regex';
import {
  setAccountEmail,
  getAccountEmail,
  setRepeatAccountEmail,
  getRepeatAccountEmail,
} from '../../features/registration/registrationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { createAccount } from '../../firebase';

import useTitle from '../../hooks/useTitle';

const CreateAccount = () => {
  const emailValueRedux = useSelector(getAccountEmail);
  const repeatEmailValueRedux = useSelector(getRepeatAccountEmail);
  const [errorMsgEmail, setErrorMsgEmail] = useState(null);
  const [errorMsgRepeatEmail, setErrorMsgRepeatEmail] = useState(null);
  const [errorList, setErrorList] = useState([]);
  const history = useHistory();
  const dispatch = useDispatch();
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'landlordReg.CreateAccount.s10',
    'Enter your email - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const updatedEmailValue = (event) => {
    dispatch(setAccountEmail(event.target.value.trim().toLowerCase()));
  };

  const updatedRepeatEmailValue = (event) => {
    dispatch(setRepeatAccountEmail(event.target.value.trim().toLowerCase()));
  };

  const errValidMessage = copyProvider.getCopy(
    'landlordReg.CreateAccount.s1',
    'Email address needs to be valid'
  );
  const errMatchMessage = copyProvider.getCopy(
    'landlordReg.CreateAccount.s2',
    'Email addresses need to match'
  );

  const handleBtnClick = () => {
    let showError;
    if (
      !checkValidEmail.test(emailValueRedux) &&
      !checkValidEmail.test(repeatEmailValueRedux)
    ) {
      showError = {
        children: errValidMessage,
      };
      setErrorMsgEmail(showError);
      setErrorMsgRepeatEmail(showError);
      setErrorList([
        { ...showError, href: '#input-with-error-message-enter-email' },
        { ...showError, href: '#input-with-error-message-repeat-email' },
      ]);
    } else if (
      checkValidEmail.test(emailValueRedux) &&
      !checkValidEmail.test(repeatEmailValueRedux)
    ) {
      showError = {
        children: errValidMessage,
      };
      setErrorMsgEmail(null);
      setErrorMsgRepeatEmail(showError);
      setErrorList([
        { ...showError, href: '#input-with-error-message-repeat-email' },
      ]);
    } else if (
      !checkValidEmail.test(emailValueRedux) &&
      checkValidEmail.test(repeatEmailValueRedux)
    ) {
      showError = {
        children: errValidMessage,
      };
      setErrorMsgEmail(showError);
      setErrorMsgRepeatEmail(null);
      setErrorList([
        { ...showError, href: '#input-with-error-message-enter-email' },
      ]);
    } else if (
      checkValidEmail.test(emailValueRedux) &&
      checkValidEmail.test(repeatEmailValueRedux)
    ) {
      if (emailValueRedux !== repeatEmailValueRedux) {
        showError = {
          children: errMatchMessage,
        };
        setErrorMsgEmail(showError);
        setErrorMsgRepeatEmail(showError);
        setErrorList([
          { ...showError, href: '#input-with-error-message-enter-email' },
          { ...showError, href: '#input-with-error-message-repeat-email' },
        ]);
      } else {
        createAccount({ email: emailValueRedux })
          .then(() => {
            setErrorMsgEmail(null);
            setErrorMsgRepeatEmail(null);
            dispatch(setAccountEmail(emailValueRedux));
            history.push('/landlordReg/check-email');
          })
          .catch((error) => {
            // TODO: add error when the server is not responding
            if (error.code === 'functions/already-exists') {
              history.push('/landlordReg/existing-email');
            } else {
              // TODO: add error when the server is not responding
              showError = {
                children: errValidMessage,
              };
              setErrorMsgEmail(showError);
              setErrorMsgRepeatEmail(null);
              setErrorList([
                { ...showError, href: '#input-with-error-message-enter-email' },
              ]);
            }
          });
      }
    }
  };

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'landlordReg.CreateAccount.s4',
          'Enter your email'
        )}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordReg.CreateAccount.s5',
          'This is the email address that you will use to sign in to your account.'
        )}
        <br />
        {copyProvider.getCopy(
          'landlordReg.CreateAccount.s6',
          'We will send a code to verify your email.'
        )}
      </p>
      <div className="govuk-form-group">
        <Input
          errorMessage={errorMsgEmail || null}
          id="input-with-error-message-enter-email"
          label={{
            children: copyProvider.getCopy(
              'landlordReg.CreateAccount.s7',
              'Enter your email address'
            ),
          }}
          className="govuk-input govuk-!-width-two-thirds"
          name="test-name-3"
          type="text"
          value={emailValueRedux}
          onChange={(event) => updatedEmailValue(event)}
        />

        <Input
          errorMessage={errorMsgRepeatEmail || null}
          id="input-with-error-message-repeat-email"
          label={{
            children: copyProvider.getCopy(
              'landlordReg.CreateAccount.s8',
              'Repeat your email address'
            ),
          }}
          className="govuk-input govuk-!-width-two-thirds"
          name="test-name-3"
          type="text"
          value={repeatEmailValueRedux}
          onChange={(event) => updatedRepeatEmailValue(event)}
        />
      </div>
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy('landlordReg.CreateAccount.s9', 'Continue')}
      </Button>
    </>
  );

  return pageModel;
};

export default CreateAccount;
